export const messages = {
    en: {
      addRoute: {
        title: 'Add Application API',
        appName:'app name',
        appId: 'app id',
        remark: 'remark',
        description: {
          label: 'Description',
          placeholder: 'Please input description (optional)'
        },
        submit: 'Submit',
        success: 'API added successfully!',
        // 新增部分
        selectApiTitle: 'Select Interface',
        serviceCode: 'service code',
        serviceName: 'service name',
        serviceId: 'service ID',
        url: 'URL',
         apiId: 'apiId',
        apiCode: 'apiCode',
        apiName: 'apiName',
      }
    },
    zh: {
      addRoute: {
        title: '新增应用API',
        appName:'应用名称',
        appId: 'app id',
        remark: '备注',
        description: {
          label: '描述',
          placeholder: '请输入描述（可选）'
        },
        submit: '提交',
        success: 'API添加成功！',
        // 新增部分
        selectApiTitle: '选择接口',
        serviceCode: '接口编码',
        serviceName: '接口名称',
        serviceId: '接口ID',
        url: 'URL',

        apiId: '接口ID',

        apiCode: '接口编码',

apiName: '接口名称',
      }
    },
    'zh-TW': {
      addRoute: {
        title: '新增應用API',
        appName:'應用名稱',
        appId: 'app id',
        remark: '備註',
        description: {
          label: '描述',
          placeholder: '請輸入描述（可選）'
        },
        submit: '提交',
        success: 'API添加成功！',
        selectApiTitle: '選擇接口',
        serviceCode: '接口編碼',
        serviceName: '接口名稱',
        serviceId: '接口ID',
        url: 'URL',
        apiId: '接口ID',
        apiCode: '接口編碼',
        apiName: '接口名稱',
      }
    }
  }